import Vue from "vue";

// Toasts of the บรอดแคสต์ screens sit at the top, like the mockup (helpers/toastr.js is bottom-right).
const ICON = {
  success: "fal fa-check-circle",
  danger: "fal fa-times-circle",
  info: "fal fa-info-circle",
};

export const bcToast = (message, type = "info") => {
  if (!message || !Vue.toasted) return;
  Vue.toasted.show(message, { position: "top-center", icon: ICON[type] + " mr-2", duration: 3500 });
};

